const validateField = function (el, char) {
  var isValid = el.value.trim().length > char;

  if (!isValid) {
    el.closest('fieldset').classList.add('has-error');
    el.closest('fieldset').setAttribute(
      'data-error',
      'To pole jest obowiązkowe, aby wziąć udział w konkursie'
    );
  } else {
    el.closest('fieldset').classList.remove('has-error');
    el.closest('fieldset').setAttribute('data-error', '');
  }
  return isValid;
};

const validateCheckbox = function (el) {
  if (!el.checked) {
    el.nextElementSibling.classList.add('has-error');
    el.classList.add('has-error');
  } else {
    el.nextElementSibling.classList.remove('has-error');
    el.classList.remove('has-error');
  }
  return el.checked;
};
